
import React, { Component } from "react";
import {Icon, Rate} from 'antd'

import {AMENITY_ICON_TYPE_MAP, AMENITY_ICON_COLOR_MAP} from '../../constants'
class TerrainAmenitiesTablet extends Component{

    constructor(props){
        super(props)
        this.fa_icon_map = {"HotTub":"et-icon-help","Spa":"et-icon-help","Swimming_pool":"et-icon-help","Free_Wifi":"et-icon-help","Free_Parking":"et-icon-help","Bath_Tub":"et-icon-help","24_Hrs Fitness":"et-icon-help","Restaurants":"et-icon-help","Key_Card Access":"et-icon-help","Non_Smoking":"et-icon-help","Elevator":"et-icon-help","Shuttle_Service":"et-icon-help","Snorkling_Service":"et-icon-help","Laundry":"et-icon-help"}
    }
    render(){
        const ars = [];
        console.log('############### this.props.amenities')
        console.log(this.props.amenities)
        let borderVal = this.props.border  
        let backgroundColorVal = this.props.backgroundColor 
        /*
        let borderVal = this.props.border  || "1px solid rgb(204, 230, 213)"
        let backgroundColorVal = this.props.backgroundColor || "#baf7f4"
        */
        const ar = this.props.amenities
        let icon_map = {}

        // /^\s*$/g
        
        if(ar && ar.length > 0){

            ar.forEach( (s, idx)=>{
                let k = s.replace(' ', '_')
            
               //let k = s.replace(regex_space, '_')
                icon_map[k] = 'et-icon-help'
            })
            console.log('############### icon_map')
            console.log(JSON.stringify(icon_map))
        }
      


       
        const sv_ams_li = this.props.amenities.map((l, k)=>{
            console.log("##################am name:", l)
            const icon_key = l.replace(' ', '_')
            let  fa_icon = AMENITY_ICON_TYPE_MAP[icon_key]
            fa_icon = fa_icon ? fa_icon :  "sketch-square"
            let color_icon = AMENITY_ICON_COLOR_MAP[icon_key]
            color_icon = color_icon? color_icon: "rgb(215, 125, 10)"

            return (
                <div className="c-box-tablet">
                <span style={{
                    fontSize: "2em",
                    marginTop:"10px",
                    marginLeft:"10px",
                    border: borderVal,
                    backgroundColor:backgroundColorVal,
                    padding: "5px"
                }}> 
                    <text className="svr-hotel-name"  style={{fontSize:"17px",verticalAlign: "middle" ,paddingRight:"10px",color:"rgb(77, 138, 17)"}}>SV5{l}</text>
    
                    <Icon  style={{ color:color_icon , fontSize:"20px" }} type={fa_icon} theme="filled" />
                </span>
               </div>
                
                )

            });

       
            return (
                <div className="container-fluid">
                     <div className="svr-gal-contentWrapper">                 
                     <div className="svr-amenity-content" >
                         <div className="svr-amenity-list-full">
                    
                        <div className="c-container-tablet">
                        {sv_ams_li}
                        </div>
                        </div>
                   
    
    
                     </div>
                    </div>
                </div>
            )
        
    }
    renderOld(){
        const sv_ams_li = this.props.amenities.map((l, k)=>{
            return (
                <div className="c-box-tablet">
                <span style={{
                    fontSize: "2em",
                    marginTop:"10px",
                    marginLeft:"10px",
                    border: "1px solid rgb(204, 230, 213)",
                    backgroundColor:"#baf7f4",
                    padding: "5px"
                }}> 
                    <text className="svr-hotel-name"  style={{fontSize:"17px", paddingRight:"10px",color:"rgb(77, 138, 17)"}}>SV5{l}</text>
    
                    <Icon  style={{ color:"rgb(215, 125, 10)" , fontSize:"20px" }} type="slack-square" theme="filled" />
                </span>
               </div>
                
                )
            });
        return (
            <div className="container-fluid">
                 <div className="svr-gal-contentWrapper">                 
                 <div className="svr-amenity-content" >
                     <div className="svr-amenity-list-full">
                
                    <div className="c-container-tablet">
                    {sv_ams_li}
                    </div>
                    </div>
               


                 </div>
                </div>
            </div>
        );
    }
}

export default TerrainAmenitiesTablet;